import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { WidgetPreview } from './WidgetPreview.js';
export function WidgetTileStub({ type, title, onOpen }) {
    const body = (_jsxs(_Fragment, { children: [_jsx(WidgetPreview, { type: type, className: "abw-stub__mark" }), _jsx("span", { className: "abw-stub__name", children: title })] }));
    // A card with nowhere to go is not a button: a focus ring on a dead target is
    // a promise the widget does not keep.
    return onOpen ? (_jsx("button", { type: "button", className: "abw-stub abw-stub--live", onClick: onOpen, title: `Open ${title}`, children: body })) : (_jsx("div", { className: "abw-stub", title: title, children: body }));
}
export default WidgetTileStub;
